export const STORAGE_KEY = 'thirdPartyTrackingData';
export const USER_PROPERTIES_STORAGE_KEY = 'userProperties';
export const CUSTOM_PARAMS_STORAGE_KEY = 'gaCustomParams';
export const CUSTOM_DIMENSIONS_STORAGE_KEY = 'gaCustomDimensions';
export const DATALAYER_STORAGE_KEY = 'tcDatalayer';
export const EVENTS_STORAGE_KEY = 'gaEvents';
export const VIRTUAL_PAGE_PATH_REGEX =
  /^\/(?:(BF|PB)\/)?([^/]+)(?:\/([^/]+)(?=\/[^/]+|$))?/;
export const MKTTRACK_COOKIE_NAME = 'mktTrack';
export const MKTSESSION_COOKIE_NAME = 'mktSession';
export const TC_VARS = 'tc_vars';
export const CLIENT_IDENTIFICATION = 'lastDateClientIdentificationCalled';
export const MARKETING_PORTAL_COOKIE_NAME = 'mktportal';
export const UTM_SOURCE_RAW_KEY = 'utmcsr';
export const UTM_SOURCE_KEY = 'utm_source';
export const UTM_MEDIUM_RAW_KEY = 'utmcmd';
export const UTM_MEDIUM_KEY = 'utm_medium';
export const UTM_CAMPAIGN_RAW_KEY = 'utmccn';
export const UTM_CAMPAIGN_KEY = 'utm_campaign';
export const UTM_CONTENT_RAW_KEY = 'utmcct';
export const UTM_CONTENT_KEY = 'utm_content';
export const UTM_TERM_RAW_KEY = 'utmctr';
export const UTM_TERM_KEY = 'utm_term';
export const UTM_GCLID_RAW_KEY = 'utmgclid';
export const UTM_GCLID_KEY = 'gclid';
